<div class="login-container">
  <div class="card-container">
    <div class="title">Connexion</div>
    <ng-container *ngIf="!showVerificationCodeForm">
            <div class="subtitle fs-16">
        Connectez vous en utilisant votre adresse mail renseignée lors de la
        création de votre compte
      </div>
      <div class="mt-3" (keyup.enter)="handleLogin()">
        <app-custom-input
          label="Email"
          [parentForm]="form"
          controlName="email"
        ></app-custom-input>
      </div>
      <div class="mt-3" (keyup.enter)="handleLogin()">
        <app-custom-input
          label="Mot de passe"
          type="password"
          [parentForm]="form"
          controlName="password"
        ></app-custom-input>
      </div>
      <app-button
        text="Connexion"
        [loading]="loading"
        (keyup.enter)="handleLogin()"
        [disabled]="form.invalid || loading"
        innerClass="mt-3 w-100"
        (handleClick)="handleLogin()"
      ></app-button>
      <div
        class="text-action text-center cursor-pointer fs-16 mt-3"
        routerLink="/forgot-password"
      >
        Mot de passe oublié?
      </div>
    </ng-container>

    <ng-container *ngIf="showVerificationCodeForm">
      <div class="subtitle fs-16">
        Veuillez entrer le code de vérification envoyé à votre adresse mail 
      </div>
      <div class="mt-3" (keyup.enter)="handleVerificationCode()">
        <app-custom-input
          label="Code de vérification"
          [parentForm]="form"
          controlName="code" 
        ></app-custom-input>
      </div>
      <app-button
        text="Connexion"
        [loading]="loading"
        (keyup.enter)="handleLogin()"
        [disabled]="form.invalid || loading"
        innerClass="mt-3 w-100"
        (handleClick)="handleVerificationCode()"
      ></app-button>
    </ng-container>

  </div>
</div>
